import {Link} from "react-router-dom";
import Icon from "../../components/selfcare/Icon.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import Routing from "../../Routing.ts";
import IconArrow from "../../components/icons/IconArrow.tsx";
import {formatDate} from "../../util/formatter.ts";
import {JobsPostings} from "./jobs.ts";
import {useMemo} from "react";

export default function JobsPage() {
    setTitleAndMetaDescription("Ledige jobs - Hiper", "Vi leder løbende efter medarbejdere med det helt rigtige Hipe. Se her hvilke stillinger, der er ledige lige nu.")

    const hasJobs = useMemo(() => {
        return Object.keys(JobsPostings).length > 0;
    }, [])

    return (
        <div className={'page-jobs'}>
            <div className={`content${hasJobs ? ' content--wide' : ''}`}>
                <div className={'blurb'}>
                    <h1 className={'heading heading--big'}>Ledige jobs</h1>
                    <p>
                        <Link to={Routing.About.Index} className={'icon-link icon-link-left icon-link-rotate-180 back-link-widget'}>
                            <Icon component={IconArrow}/> <span className={'text'}>Tilbage</span>
                        </Link>
                    </p>
                </div>

                <div className="blurb">
                    <h2 className={'heading heading--montserrat heading--medium'}>Jobopslag</h2>
                    {hasJobs ? (
                        <p>
                            Herunder kan du se de ledige stillinger, vi har lige nu.
                        </p>
                    ) : (
                        <p>
                            Vi har desværre ingen ledige stillinger lige nu.
                            Hvis du stadig er interesseret i at arbejde hos Hiper, kan du se hvordan du ansøger længere nede på siden.
                        </p>
                    )}
                </div>

                {hasJobs && (
                    <div className={'grid'}>
                        {Object.entries(JobsPostings).map(([key, job]) => {
                            return (
                                <div key={key} className={'item'}>
                                    <div className={'wrap-thing'}>
                                        <img src={job.img_list} alt={job.img_alt}/>
                                        <div className={'wrap-thing-bar'}>
                                            <Link to={job.link}>
                                                Læs mere
                                                <Icon component={IconArrow}/>
                                            </Link>
                                        </div>
                                    </div>
                                    <h3 className={'heading heading--montserrat heading--small'}>
                                        {job.heading}
                                        <span className={'heading__title'}>
                                            {formatDate(job.date)}
                                        </span>
                                    </h3>
                                </div>
                            )
                        })}
                    </div>
                )}

            </div>
            <div className={'content'}>
                <h2 className={'heading heading--montserrat heading--medium'}>Bliv en del af teamet!</h2>
                <p className={'align-center'}>
                    Vi leder efter dygtige mennesker der vil være med til at gøre Hiper til Danmarks bedste bredbåndsselskab.
                    Hiper er en vækstvirksomhed, som stadig har et start-up mindset, men størrelsen til at nå bredt ud.
                    Hos os har vi rammerne, hvor dit talent og engagement kan bidrage til yderlig vækst, hvor vi står klar til at give fagligt ansvar og sparring.
                </p>
                <p className={'align-center'}>
                    Ambitionerne er høje, så selv når vi ikke har nogen ledige stillinger, er du mere end velkommen til at sende en ansøgning til os på{' '}
                    <a href={'mailto:job@hiper.dk'}>job@hiper.dk</a>.
                </p>
            </div>
        </div>
    )
}
